class Docuseries extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      channel: '[data-channel]',
      channelTabs: '[data-channel-tabs]',
      channelToggler: '[data-channel-toggler]',
      loadingSpinner: '.loading__spinner',
      playerId: 'DocuseriesPlayer',
      season: '[data-season]',
      seasonToggler: '[data-season-toggler]',
      shop: '[data-shop]',
      videoCard: '[data-video-card]',
      videoThumbnail: '[data-video-thumbnail]',
      videoTrigger: '[data-video-trigger]'
    }

    this.classes = {
      active: 'active',
      hidden: 'hidden',
      loading: 'loading'
    }

    this.data = {
      channelId: 'channelId',
      plyrEmbedId: 'plyrEmbedId',
      plyrProvider: 'plyrProvider',
      shopCollectionUrl: 'shopCollectionUrl',
      tabId: 'tabId',
      seasonId: 'seasonId',
      videoId: 'videoId'
    }

    this.attr = {
      loading: 'loading',
      plyrEmbedId: 'data-plyr-embed-id',
      seasonId: 'data-season-id',
      tabId: 'data-tab-id'
    }

    this.mqlMobile = window.matchMedia('(max-width: 749px)');

    this.channelTabs = this.querySelector(this.selectors.channelTabs);
    this.seasonTogglers = this.querySelectorAll(this.selectors.seasonToggler);
    this.shop = this.querySelector(this.selectors.shop);
    this.videoTriggers = this.querySelectorAll(this.selectors.videoTrigger);
    
    if (typeof Plyr === "undefined") return;

    this.playerMobileIsLoading = false;
    this.plyrPlayerOptions = {
      playsinline: true,
      fullscreen: {
        enabled: true, 
        fallback: true, 
        iosNative: true, 
        container: null
      }
    }

    this.checkURL();
    // if (!this.mqlMobile.matches) this.initPlayer();
    this.initPlayer();    
    this.initEvents();
    
  }

  checkURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('channel')) {
      const channelId = urlParams.get('channel');
      this.channelTabs.openTab(channelId);
    }

    if (urlParams.has('season')) {
      const seasonId = urlParams.get('season');
      const currentChannel = [...this.querySelectorAll(this.selectors.channel)].find(c => c.classList.contains(this.classes.active));
      const seasons = currentChannel?.querySelectorAll(this.selectors.season);

      if (seasons && seasons.length) {
        const season = [...seasons].find(s => s.dataset[this.data.seasonId] == seasonId);
        if (season) {
          const seasonToggler = currentChannel.querySelector(this.selectors.seasonToggler);
          seasonToggler.setValue(seasonId);
          this.openSeason(seasons, season);
        }
      }
    }

    if (urlParams.has('video')) {
      const videoId = urlParams.get('video');
      document.getElementById(this.selectors.playerId).setAttribute(this.attr.plyrEmbedId, videoId);
    }
    
  }

  initPlayer() {
    this.currentVideoId = document.getElementById(this.selectors.playerId).dataset[this.data.plyrEmbedId] || false;

    this.player = new Plyr(`#${this.selectors.playerId}`, this.plyrPlayerOptions);
    this.player.on('ready', this.playPlayer);
    plyrCustomEvents.addEvents(this.player);
    setTimeout(() => { this.bindAnalyticsVideoEvents() }, 2000);
    
  }

  initEvents() {
    this.channelTabs.addEventListener('tabChange', this.onChannelChange.bind(this));
    this.videoTriggers.forEach((vt) => vt.addEventListener('click', this.onVideoTrigger.bind(this)));
    this.seasonTogglers.forEach((st) => st.addEventListener('change', this.changeSeason.bind(this)));
    this.mqlMobile.addEventListener('change', () => { if (!this.mqlMobile.matches) this.initPlayer(); });
  }

  onVideoTrigger(e) {
    e.preventDefault();
    const target = e.currentTarget;
    const videoId = !!target.dataset[this.data.videoId] ? target.dataset[this.data.videoId] : false;
    const collectionUrl = !!target.dataset[this.data.shopCollectionUrl] ? target.dataset[this.data.shopCollectionUrl] : false

    if (!videoId) return;
    
    if (false && this.mqlMobile.matches) {
      this.createPlayerMobile(videoId, target);
      
    } else {
      this.playVideo(videoId);
    }

    // if(collectionUrl) this.getShop(collectionUrl, this.showShop)
    
  }
  
  playPlayer = () => {
    this.player.play().catch(error => {
      this.player.muted = true;
      this.player.volume = 0;
      setTimeout(this.player.play, 500);
    });
  }

  createPlayerMobile(videoId, trigger) {
    if (this.playerMobileIsLoading) return;
    this.playerMobileIsLoading = true;
    this.handleLoading(trigger, true);
    const plyrContainer = document.createElement('div');
    const plyrElement = document.createElement('div');

    // plyrContainer.style.cssText = `
    //   position: fixed;
    //   left: -200vw;
    //   width: 0;
    //   height: 0;
    //   overflow: hidden;
    //   z-index: -10;
    // `;

    plyrElement.dataset[this.data.plyrProvider] = 'vimeo';
    plyrElement.dataset[this.data.plyrEmbedId] = videoId;
    plyrContainer.appendChild(plyrElement);
    document.body.appendChild(plyrContainer);
    
    const plyr = new Plyr(plyrElement, {
      fullscreen: {
        enabled: true, 
        fallback: true, 
        iosNative: true, 
        container: null
      }
    });
    
    plyr.on('ready', (e) => {
      const player = e.detail.plyr;
      player.muted = true;
      player.volume = 0;
      
      setTimeout(() => {        
        player.fullscreen.enter();
        player.play();
        this.playerMobileIsLoading = false;
        this.handleLoading(trigger, false);
      }, 2000);
    });

    plyrCustomEvents.addEvents(plyr);
    
    // plyr.on('exitfullscreen', (e) => {
    //   const player = e.detail.plyr;
    //   player.destroy();
    //   plyrContainer.remove();
    // });
    
  }

  handleLoading(target, isLoading) {
    const videoCard = target.closest(this.selectors.videoCard);
    const thumbnail = videoCard.querySelector(this.selectors.videoThumbnail);
    const triggers = videoCard.querySelectorAll(this.selectors.videoTrigger);

    if (isLoading) {    
      thumbnail.querySelector(this.selectors.loadingSpinner).classList.remove(this.classes.hidden);
      thumbnail.classList.add(this.classes.loading);      
    } else {
      thumbnail.querySelector(this.selectors.loadingSpinner).classList.add(this.classes.hidden);
      thumbnail.classList.remove(this.classes.loading);
    }
    
  }
  
  changePlayerVideoSource(videoId) {
    if (this.currentVideoId === videoId) return;
    
    const url = new URL(window.location);
    url.searchParams.set('video', videoId);
    window.history.pushState({}, '', url); 
    
    this.player.off('ready', this.playPlayer);
    plyrCustomEvents.removeEvents(this.player);
    if (this.plyrAnalyticsEventsUnsubscriber) this.plyrAnalyticsEventsUnsubscriber();
    
    this.player.on('ready', this.playPlayer);
    plyrCustomEvents.addEvents(this.player); 
    this.bindAnalyticsVideoEvents();
    
    this.player.source = {
      type: 'video',
      sources: [
        {
          src: videoId,
          provider: 'vimeo',
        },
      ],
    };

    this.currentVideoId = videoId;

  }

  playVideo(videoId) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    this.changePlayerVideoSource(videoId);

  }

  onChannelChange(e) {
    const channelToggler = e.detail.tabTogglers[0];
    const channel = channelToggler.dataset[this.data.tabId];
    const channelHasSeasons = !!this.querySelector(`${this.selectors.channel}[${this.attr.tabId}="${channel}"]`)?.querySelectorAll(this.selectors.season).length;
    const videoId = !!channelToggler.dataset[this.data.videoId] ? channelToggler.dataset[this.data.videoId] : false

    if (videoId) this.changePlayerVideoSource(videoId);

    const url = new URL(window.location);
    url.searchParams.set('channel', channel);
    url.searchParams.set('video', videoId);
    if (!channelHasSeasons && url.searchParams.has('season')) url.searchParams.delete('season');  
    window.history.pushState({}, '', url); 
    
  }

  changeSeason(e) {
    const target = e.target;
    const seasonId = e.detail.value;
    const currentChannel = target.closest(this.selectors.channel);
    const seasons = currentChannel.querySelectorAll(this.selectors.season);
    const season = currentChannel.querySelector(`${this.selectors.season}[${this.attr.seasonId}="${seasonId}"]`);

    if (!season) return;
    this.openSeason(seasons, season);
    
    const url = new URL(window.location);
    url.searchParams.set('season', seasonId);
    window.history.pushState({}, '', url);
  }

  openSeason(seasons, season) {
    seasons.forEach((s) => s.classList.remove(this.classes.active));
    season.classList.add(this.classes.active);
  }

  bindAnalyticsVideoEvents() {
     if (window.analyticsEvents) {
      this.plyrAnalyticsEventsUnsubscriber = window.analyticsEvents.attachPlyrVideoEvents({
        player: this.player,
        video_url: `https://vimeo.com/${this.currentVideoId}`
      });
    }
  }
  
  getShop(collectionUrl, callback) {
    fetch(`${collectionUrl}?section_id=main-collection-product-grid`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const products = html.querySelectorAll('#product-grid li:not(.collection__grid-banner)');

        callback(products);
      })
      .catch((e) => {
        console.error(e);
      });
    
  }

  showShop = (products) => {
    const productGrid = document.createElement('ul');
    productGrid.classList.add('grid', 'grid--2-col', 'grid--3-col-desktop');
    products.forEach((p) => {productGrid.appendChild(p)});
    this.shop.appendChild(productGrid);
    
  }
  
}

customElements.define('docuseries-component', Docuseries);